<!-- Page Wrapper -->
<div class="page-wrapper" style="min-height: 347px;">
    <div class="content container-fluid">
        <div class="bg-white page-border fullbox">
            <!--page body contant -->
            <!--header-->
            <div class="row row-replace add-m-b">
                <div class="col-md-6 col-8 col-p h5"><i class="fa fa-globe"></i> Travel Search </div>
                <div class="col-md-6 col-4 top-corner-items col-p">
                    <!-- <button class="btn btn-primary btn-sm" [routerLink]="['/dashboard/traval-contract-list']"><i class="fa fa-plus"></i> Add New Vendor</button> -->
                </div>
            </div>
            <!--end header-->

            
            <div class="row row-replace bg-light p-10 align-items-center shadow1">
           
                      <div class="col-md-3">
                         <div class="form-group">
                         <label>From</label>
                         <select class="form-control">
                            <option hidden></option>
                            <option>Car</option>
                            <option>Hotal</option>
                            <option>Car with Hotal</option>
                         </select>
                        </div>
                      </div>
                      <div class="col-md-3">
                        <div class="form-group">
                         <label>To</label>
                         <select class="form-control">
                            <option hidden></option>
                            <option>Outstation</option>
                         </select>
                         </div>
                      </div>
                      <div class="col-md-2">
                        <div class="form-group">
                         <label>Departure</label>
                         <input type="date" class="form-control">
                         </div>
                      </div>
                      <div class="col-md-2">
                        
                        <div class="form-check form-check-inline">
                           <input class="form-check-input" type="checkbox">
                           <label class="form-check-label">Car</label>
                         </div>
                         <div class="form-check form-check-inline">
                           <input class="form-check-input" type="checkbox">
                           <label class="form-check-label" >Hotal</label>
                         </div>
                      </div>
                      <div class="col-md-2 align-self-center text-center">
                        <button class="btn btn-success">Search</button> 
                      </div>
             </div>

             <div class="row row-replace m-t-20">
                <div class="col-md-4 border">
                  <div class="row">
                     <div class="col-12">Searching</div>
                  </div>
                </div>
                <div class="col-md-8 border">
                   <div class="row">
                      <div class="col-12">Header</div>
                      
                   </div>
                </div>
             </div>

            
        
          

      <!--end page body contant -->
        </div>
    </div>
</div>
<!-- /Page Wrapper -->         


